import type { CreateReportAction } from '~/store/frontendState/createReport/createReport.action';
import {
  createReportAddItem, createReportRemoveItem, createReportUpdateItem,
} from '~/store/frontendState/createReport/createReport.actionCreators';
import type { CreateReportState } from '~/store/frontendState/createReport/createReport.state';

export const createReportInitialState: CreateReportState = {
  items: [],
};

export const createReportReducer = (
  state = createReportInitialState,
  action: CreateReportAction
): CreateReportState => {
  if (createReportAddItem.match(action)) {
    const newItems = state.items.filter(item => item.hash !== action.payload.item.hash);
    newItems.push(action.payload.item);

    return {
      ...state,
      items: newItems,
    };
  }

  if (createReportUpdateItem.match(action)) {
    const newItems = state.items.map(item => {
      if (item.hash !== action.payload.item.hash) {
        return item;
      }

      return action.payload.item;
    });

    return {
      ...state,
      items: newItems,
    };
  }

  if (createReportRemoveItem.match(action)) {
    return {
      ...state,
      items: state.items.filter(item => item.hash !== action.payload.hash),
    };
  }

  return state;
};
